<template>
  <b-row>
    <b-col>
      <p>The following Vendor RMAs are returning actions that are open to be shipped</p>
      <!--<filters-component :filters="poDueFilters" :keyNdx="1" @onSearch="getData"/>-->

      <div class="flex-column">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <b-form-group label="Vendor" class="mr-2">
              <b-form-input v-model="vrmaToBeShippedFilters.vendor"  @input="onSearch" size="sm" />
            </b-form-group>
            <b-form-group label="Purchase Order #" class="mr-2">
              <b-form-input v-model="vrmaToBeShippedFilters.purchaseOrderId"  @input="onSearch" size="sm" />
            </b-form-group>
          </div>
        </div>
      </div>

      <vendor-rma-list
        :vendorRmaParentList="vrmaToBeReturned"
        isParentList
        @selectedSourceObj="onVRMASelect"
        @onSort="onSort"
        :gridId="gridId"
        class="mt-1" />

      <div class="flex-column mt-4">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <b-button size="sm" variant="primary" :disabled="selectedPoLineId == 0 || isGettingInventories" @click="onShowPickList" class="mr-2">
              <i v-show="isGettingInventories" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
              {{ isGettingInventories ? 'Getting' : '' }} Pick List
            </b-button>
          </div>
        </div>
      </div>

      <vendor-rma-lines :vendorrmaId="selectedVRMAId"
                        :gridId="gridLines"
                        isFilteredList
                        :vrmaLinesFiltered="vrmaLinesToBeReturned" class="mt-1"
                        @selectedRMALine="onVRMALineSelect"/>

      <pick-list-modal
        :pickTicketList="vramInventoryForReturning"
        :modalId="modalId"
        :poLineId="selectedPoLineId"
        :vendorRMAId="selectedVRMAId"
        :vendorRMALineId="selectedvendorRMALineId"
        @refreshData="onSearch"  />
    </b-col>
  </b-row>

</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  import { DATE_FORMAT, GRID_ID} from '@/shared/constants';
  import VendorRmaList from '@/shared/components/VRMA';
  import VendorRmaLines from '@/shared/components/VRMALines';
  import PickListModal from './components/PickList'

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    components: {
      VendorRmaList,
      VendorRmaLines,
      PickListModal
    },
    data() {
      return {
        DATE_FORMAT,
        vrmaToBeShippedFilters: {},
        selectedVRMAId: 0,
        selectedvendorRMALineId: 0,
        selectedPoLineId: 0,
        gridId: GRID_ID.VENDORRMAS_RETURNED,
        gridLines: GRID_ID.VENDORRMAS_RETURNED_LINES,
        modalId: 'vendor-rma-return-pick-list',
        isGettingInventories: false
      };
    },
    computed: {
      ...mapGetters('shippingReceiving', [
        'vrmaToBeReturned', 'vrmaLinesToBeReturned', 'vramInventoryForReturning'
      ]),
      //remove-below
      // ...mapGetters('vendorrmas', ['vrmasList'])
    },
    methods: {
      ...mapActions('shippingReceiving', ['getVrmaToBeReturned', 'getVrmaLinesBySelectedRma', 'getInventoriesForReturningVrma', 'setSortInfo']),
      ...mapMutations('shippingReceiving', ['setItem']),
      //remove-below
      // ...mapActions('vendorrmas', ['getAll']),
        async onSearch() {
          
          await this.getVrmaToBeReturned({
            filters: {
              ...this.vrmaToBeShippedFilters,
            }
          });
          // this.getAll({});
      },
      async onVRMASelect($event) {
        this.selectedVRMAId = $event.id;
        this.selectedPoLineId = 0;
        await this.getVrmaLinesBySelectedRma({
          vendorRmaId: $event.id,
          isState: 'vrmaLinesToBeReturned'
        });
      },
      async onVRMALineSelect($event) {
        this.isGettingInventories = true;
        this.selectedvendorRMALineId = $event.id;
        this.selectedPoLineId = $event.poLineId;
        this.setItem({ resource: 'vramInventoryForReturning', payload: [] });
        await this.getInventoriesForReturningVrma($event.poLineId);
        this.isGettingInventories = false;
      },
      onShowPickList() {
        this.$bvModal.show(this.modalId);
      },
      onSort(evt) {
        this.setSortInfo({ ...evt, pageInfoState: 'vrmaPageInfo' }).then(() => this.onSearch());
      }
    },
    mounted() {
      this.setItem({ resource: 'vrmaLinesToBeReturned', payload: [] });
      this.onSearch();
    }
  }
</script>

<style scoped>
  .sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
  }
</style>